import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { 
  AlignedGrid, QuoteComparisonExpansionPanel, 
  createLoanGridElements, createLoanGridLabel, 
  QuoteComparisonExpansionPanelDetails,
  createAbbreviatedMoneyLoanGridElements,
  QuoteComparisonExpansionSummary } from './QuoteComparisonGridElements';

class LoanAmount extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }

  render() {
    const { loans, isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Loan Amount")}
            {expanded && createAbbreviatedMoneyLoanGridElements(loans, 'loanAmount',isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Initial Proceeds")}
            {createAbbreviatedMoneyLoanGridElements(loans, 'initialProceeds',isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default LoanAmount;